import { config } from '@/forms/config';
import type {
  FormConditionalValidation,
  FormField,
  FormInitialValues,
  FormValidations,
} from '@/forms/typings';
import type { CheckboxGroupFormField } from '@/forms/typings';

import type { FormFieldModuleContext } from '../registry/field-module.types';

export function buildCheckboxGroupInitialState(
  field: FormField,
  values: FormInitialValues,
  validations: FormValidations,
  conditions: FormConditionalValidation[] | undefined,
  ctx: FormFieldModuleContext,
): { initialValues: FormInitialValues; validationFields: FormValidations } {
  let initialValues: FormInitialValues = { ...values };
  let validationFields: FormValidations = { ...validations };

  const f = field as CheckboxGroupFormField;

  const shouldValidateFieldId = `${f.fieldId}${config.shouldValidateFieldSuffix}`;

  initialValues[shouldValidateFieldId] = true;
  initialValues[f.fieldId] = f.value;

  const combinedConditions: FormConditionalValidation[] = [
    {
      type: 'should-validate',
      relatedFieldId: shouldValidateFieldId,
    },
  ];

  if (conditions) {
    combinedConditions.push(...conditions);
  }

  for (const inner of f.fields) {
    const detailValuesAndValidations = ctx.recurse(
      inner,
      initialValues,
      validationFields,
      combinedConditions,
    );

    initialValues = {
      ...initialValues,
      ...detailValuesAndValidations.initialValues,
    };
    validationFields = {
      ...validationFields,
      ...detailValuesAndValidations.validationFields,
    };
  }

  return { initialValues, validationFields };
}
